import { addPersonalisedProductToBasket } from './addPersonalisedProductToBasket';
import { addProductToBasket } from './addProductToBasket';

/**
 * Determines whether to add a personalised or non-personalised product.
 * @param {HTMLButtonElement} button - The 'Add to basket' button event listener.
 * @param {number} productId - The ID of the product being added.
 * @param {string} [productName] - The name of the product, if available.
 * @param {string} productType - The type of product.
 * @param {number} quantity - The type of product.
 * @param {boolean} isPersonalised - Whether the product is personalised.
 * @param {string} depositPrice - The deposit price if present.
 */
export function addProduct(
	button: HTMLButtonElement,
	productId: number,
	productName: string | undefined,
	productType: string,
	quantity: number,
	isPersonalised: boolean,
	depositPrice: string | null,
): void {
	if (isPersonalised) {
		addPersonalisedProductToBasket(button, productId, productType, quantity);
	} else {
		addProductToBasket(button, productId, productName, productType, quantity, depositPrice);
	}
}
